import { useEffect, useState } from "react";
import { isTokenPresent } from "../../utils/cookieHelper";
import { useStore } from "../../store/useStore";
import { END_OF_RESPONSE } from "../../services/RecentActivity/recentTransactions/recentTransaction.constants";
import fetchOrders from "../../services/RecentActivity/recentOrders/recentOrders.service";
import { setOrdersLoading } from "../../store/slices/recentActivity/recentActivity.setters";
import { AUTH_LEVEL } from "../../utils/constants";

const useGetOrders = (trigger = false) => {
  const [fetchNextOrders, setFetchNextOrders] = useState(
    trigger
  );

  const nextPageToken = useStore(
    state => state.ordersNextPageToken
  );

  const ordersLoading = useStore(
    state => state.ordersLoading
  );

  const authLevel = useStore(state => state.authLevel);

  useEffect(() => {
    if (
      !isTokenPresent() ||
      ordersLoading ||
      authLevel !== AUTH_LEVEL.SECOND_FACTOR
    )
      return;
    if (
      fetchNextOrders &&
      nextPageToken !== END_OF_RESPONSE
    ) {
      // setOrdersLoading(true);
      fetchOrders(nextPageToken);
      setFetchNextOrders(false);
    }
  }, [fetchNextOrders, authLevel]);

  return { setFetchNextOrders };
};

export default useGetOrders;
